import * as React from "react";
const SvgIconWindowsreact = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="#28A2FA" d="M7.5 2.504h-5v5h5zM13.5 2.504h-5v5h5zM8.5 8.504h5v5h-5zM7.5 8.504h-5v5h5z" /></svg>;
export default SvgIconWindowsreact;